import { CommitFn } from "../../../../../rest/Commit";
import { FlagActions } from "../../../../flux/Flag/FlagActions";
import { ErrorActions } from "../../../../flux/Error/ErrorActions";
import { ListActions } from "../../../../flux/Grid/ListActions";
import { EntityType, PersonDraft } from "../../../../../models";
import { Polyglot } from "../../../../../polyglot";
import { appNavigator } from "../../../../routes";

export class UpsertPersonCommand
{
    private inProgressActions = new FlagActions();
    private listActions = new ListActions();
    private errorActions = new ErrorActions();
    
    constructor(
        private polyglot: Polyglot,
        private commit: CommitFn,
        private listDispatchToken: string, private inProgressDispatchToken: string, private errorDispatchToken)
    {
    }

    execute = (draft: PersonDraft) => {
        if(!draft)
            throw new Error('Program error. draft has to have value');

        const { DivisionRegId, Firstname, Username, Password, PasswordConfirmation } = draft;
        const setError = (msg: string) => this.errorActions.setError(new Error(msg), this.errorDispatchToken);
        if(typeof DivisionRegId !== 'number') {
            setError(this.polyglot.t('person.validation_err.division_not_set'));
            return;
        }
        if(typeof Firstname !== 'string' || Firstname === '') {
            setError(this.polyglot.t('person.validation_err.empty_first_name'));
            return;
        }
        if(typeof Username !== 'string' || Username === '') {
            setError(this.polyglot.t('person.validation_err.empty_username'));
            return;
        }
        if(Password !== PasswordConfirmation) {
            setError(this.polyglot.t('person.validation_err.password_mismatch'));
            return;
        }
        
        delete draft.PasswordConfirmation;
        if(Password === '') {
            delete draft.Password;
        }

        const entityType = EntityType.Person;
        this.inProgressActions.set(this.inProgressDispatchToken);
        this.commit({ type: entityType, entity: draft })
            .then(res => {
                if(res.Success) return res[EntityType[entityType]];
                throw new Error(res.ErrorMessage);
            })
            .then(entity => {
                this.listActions.upsertItems([entity], entityType);
                appNavigator.goToPersonTab();
            })
            .catch(err => this.errorActions.setError(err, this.errorDispatchToken ))
            .then(() => this.inProgressActions.reset(this.inProgressDispatchToken)); // finaly
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Person/commands/UpsertPersonCommand.ts